/*!
 * Built by Revolist
 */
import { O as OrderEditor, d as defineCustomElement$1 } from './revogr-order-editor2.js';

const RevogrOrderEditor = OrderEditor;
const defineCustomElement = defineCustomElement$1;

export { RevogrOrderEditor, defineCustomElement };
